// extracted by mini-css-extract-plugin
export default {"couponSection":"PointsSummary_couponSection__5SjNj","planSection":"PointsSummary_planSection__qToNi"};